import Data from '../Data.json'

export function storeList() {
  return {
    type: "STORE_ITEMS",
    payload: Data
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js